<template>
  <div @click="toggleSwitch" :style="trackStyle">
    <div :style="labelStyle">{{ isOn ? "Shown" : "Hidden" }}</div>
    <div :style="knobStyle"></div>
  </div>
</template>

<script>
export default {
  name: "CustomSwitch",
  props: {
    value: {             // <-- Vue 2 v-model uses `value` prop
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "sm",
      validator: (v) => ["xs", "sm", "md", "lg"].includes(v),
    },
    widthPercent: {
      type: Number,
      default: 65,
    },
  },
  computed: {
    isOn() {
      return this.value;
    },
    sizes() {
      return {
        xs: { trackHeight: 24, trackPadding: 4, knobWidth: 20, knobHeight: 16, fontSize: "10px" },
        sm: { trackHeight: 32, trackPadding: 6, knobWidth: 28, knobHeight: 24, fontSize: "12px" },
        md: { trackHeight: 44, trackPadding: 14, knobWidth: 42, knobHeight: 34, fontSize: "14px" },
        lg: { trackHeight: 60, trackPadding: 20, knobWidth: 52, knobHeight: 46, fontSize: "16px" },
      };
    },
    currentSize() {
      return this.sizes[this.size];
    },
    trackStyle() {
      return {
        width: this.widthPercent + "%",
        height: this.currentSize.trackHeight + "px",
        borderRadius: "6px",
        background: this.isOn ? "#0074D9" : "#ADB5BD",
        position: "relative",
        cursor: "pointer",
        transition: "0.25s ease",
        display: "flex",
        alignItems: "center",
        padding: `0 ${this.currentSize.trackPadding}px`,
        boxSizing: "border-box",
        userSelect: "none",
      };
    },
    labelStyle() {
      return {
        color: "#fff",
        fontWeight: "600",
        fontSize: this.currentSize.fontSize,
        width: "100%",
        textAlign: this.isOn ? "left" : "right",
        transition: "0.25s ease",
        zIndex: 2,
        pointerEvents: "none", // allow clicks through
      };
    },
    knobStyle() {
      return {
        width: this.currentSize.knobWidth + "px",
        height: this.currentSize.knobHeight + "px",
        borderRadius: "4px",
        background: "#fff",
        position: "absolute",
        top: (this.currentSize.trackHeight - this.currentSize.knobHeight) / 2 + "px",
        left: this.isOn
          ? `calc(100% - ${this.currentSize.knobWidth + this.currentSize.trackPadding}px)`
          : this.currentSize.trackPadding + "px",
        transition: "0.25s ease",
        boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
        zIndex: 1,
        pointerEvents: "none",
      };
    },
  },
  methods: {
    toggleSwitch() {
      this.$emit("input", !this.value); // <-- Vue 2: emit `input` for v-model
    },
  },
};
</script>
